import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import PublicLayout from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Teams from "@/pages/Teams";
import TeamDetail from "@/pages/TeamDetail";
import Schedule from "@/pages/Schedule";
import Live from "@/pages/Live";
import Standings from "@/pages/Standings";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import ScoreSheet from "@/pages/ScoreSheet";
import Officials from "@/pages/Officials";

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <div className="min-h-screen bg-[#08080C] text-slate-100">
                    <div className="grain-overlay" />
                    <Routes>
                        <Route element={<PublicLayout />}>
                            <Route path="/" element={<Home />} />
                            <Route path="/teams" element={<Teams />} />
                            <Route path="/teams/:teamId" element={<TeamDetail />} />
                            <Route path="/schedule" element={<Schedule />} />
                            <Route path="/live" element={<Live />} />
                            <Route path="/standings" element={<Standings />} />
                            <Route path="/officials" element={<Officials />} />
                        </Route>
                        <Route path="/scoresheet/:gameId" element={<ScoreSheet />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                    </Routes>
                    <Toaster theme="dark" position="top-center" richColors />
                </div>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
